import { render, staticRenderFns } from "./DesktopLayout.vue?vue&type=template&id=581e3e48&scoped=true"
import script from "./DesktopLayout.vue?vue&type=script&lang=js"
export * from "./DesktopLayout.vue?vue&type=script&lang=js"
import style0 from "./DesktopLayout.vue?vue&type=style&index=0&id=581e3e48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "581e3e48",
  null
  
)

export default component.exports